import React from 'react';
import PropTypes from 'prop-types';

import {
  ActionsCheckNormalSmall,
  ActionsCheckNormalMedium
} from '@strava/icons';

import styles from './index.scss';

const ChecklistSection = ({ checklistSection }) => {
  const stravaOrangeHex = '#FC5200';
  const checkIconSmall = <ActionsCheckNormalSmall fill={stravaOrangeHex} />;
  const checkIconMedium = <ActionsCheckNormalMedium fill={stravaOrangeHex} />;

  const renderMobileChecklistCategory = (label, items) => {
    return (
      <div key={label}>
        <p className={styles.subtitle2}>{label}</p>
        <div className={styles.checklistCategory}>
          {items.map((item) => (
            <div className={styles.mobileItemRow} key={`mobile-${item.text}`}>
              {checkIconSmall}
              <p className={`${styles.body2} ${styles.mobileItemText}`}>
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const subscriptionItems = checklistSection.items.filter(
    (i) => i.subscription
  );
  const freeItems = checklistSection.items.filter((i) => i.free);

  return (
    <div>
      <div className={`col-xs-12 ${styles.checklistSection}`}>
        <div className={`container ${styles.container} ${styles.desktop}`}>
          <div className={`${styles.row}`}>
            <div className="col-xs-12">
              <p className={`${styles.headline2} ${styles.checklistHeadline}`}>
                {checklistSection.headline}
              </p>
            </div>
          </div>
        </div>

        {/* Mobile Checklist Rows */}
        <div className={styles.mobile}>
          {renderMobileChecklistCategory(
            checklistSection.subscription_label,
            subscriptionItems
          )}
          {renderMobileChecklistCategory(
            checklistSection.free_label,
            freeItems
          )}
        </div>

        {/* Desktop Checklist Table */}
        <div className={`container ${styles.container} ${styles.desktop}`}>
          <div className={`${styles.row}`}>
            <div
              className={`col-xs-4 ${styles.subtitle2} ${styles.checklistHeaders}`}
            >
              {checklistSection.item_label}
            </div>
            <div
              className={`col-xs-2 text-center ${styles.subtitle2} ${styles.checklistHeaders}`}
            >
              {checklistSection.free_label}
            </div>
            <div
              className={`col-xs-2 text-center ${styles.subtitle2} ${styles.checklistHeaders}`}
            >
              {checklistSection.subscription_label}
            </div>
          </div>
          {checklistSection.items.map((item, index) => {
            const showDivider = checklistSection.items.length !== index + 1;
            return (
              <div key={item.text}>
                <div className={styles.row}>
                  <div className={styles.checklistRow}>
                    <div className={`col-xs-4 ${styles.body2}`}>
                      {item.text}
                    </div>
                    <div className="col-xs-2 text-center">
                      {item.free && checkIconMedium}
                    </div>
                    <div className="col-xs-2 text-center">
                      {item.subscription && checkIconMedium}
                    </div>
                  </div>
                </div>
                {showDivider && (
                  <div className={styles.row}>
                    <div className={`col-xs-8 ${styles.checklistDivider}`} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

ChecklistSection.propTypes = {
  checklistSection: PropTypes.shape({
    headline: PropTypes.shape.isRequired,
    item_label: PropTypes.string.isRequired,
    free_label: PropTypes.string.isRequired,
    subscription_label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        free: PropTypes.bool.isRequired,
        subscription: PropTypes.bool.isRequired
      })
    )
  }).isRequired
};

export default ChecklistSection;
